import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { FlameIcon } from "@phosphor-icons/react";
import { toast } from "sonner";

/**
 * Daily-login streak badge shown in the Navbar for signed-in users.
 * Fires `/api/me/streak/ping` once per session; if a reward was granted
 * (7-day or 30-day milestone), shows a celebratory toast.
 */
export default function StreakBadge({ user }) {
  const [streak, setStreak] = useState(user?.streak_days || 0);

  useEffect(() => {
    if (!user) return;
    // Dedupe within the same tab so we don't spam the endpoint.
    if (sessionStorage.getItem("bidora_streak_pinged_today")) {
      setStreak(user.streak_days || 0);
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/me/streak/ping");
        setStreak(data.streak_days || 0);
        sessionStorage.setItem("bidora_streak_pinged_today", "1");
        if (data.awarded_cents > 0) {
          toast.success(
            `🔥 ${data.streak_days}-day streak! +$${(data.awarded_cents / 100).toFixed(0)} credit unlocked`,
            { duration: 6000 }
          );
        }
      } catch {
        /* silent — not critical */
      }
    })();
  }, [user]);

  if (!user || streak <= 0) return null;

  return (
    <div
      className="inline-flex items-center gap-1 bg-orange-100 text-orange-700 rounded-full px-2.5 py-1 text-xs font-bold"
      title={`${streak}-day login streak`}
      data-testid="streak-badge"
    >
      <FlameIcon size={12} weight="fill" />
      {streak}
    </div>
  );
}
